import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-b9773072"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = {
  class: "top-main"
};
const _hoisted_3 = ["src"];

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "app-title"
}, "面具约会", -1));

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "app-desc"
}, "真人认证，真诚交友", -1));

const _hoisted_6 = {
  class: "install-main"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "install-title"
}, "安装教程", -1));

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "install-desc"
}, "1、点击免费下载，安装APP", -1));

const _hoisted_9 = ["src"];

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "install-desc"
}, "2、在手机中打开设置功能，选择\"通用\"", -1));

const _hoisted_11 = ["src"];

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "install-desc"
}, "3、在通用中，选择\"VPN与设备管理\"功能", -1));

const _hoisted_13 = ["src"];

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "install-desc"
}, "4、在企业级APP中，找到面具约会APP，点击信任对应公司名称", -1));

const _hoisted_15 = ["src"];
const _hoisted_16 = ["src"];

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "install-desc"
}, "5、回到桌面，重新打开应用即可使用", -1));

const _hoisted_18 = ["src"];
const _hoisted_19 = {
  class: "tips-val"
};

const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 点击右上角 ");

const _hoisted_21 = ["src"];

const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 选择\"浏览器中打开\"");

const _hoisted_23 = ["src"];
const _hoisted_24 = {
  key: 1,
  class: "hide_back"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    class: "icon",
    src: $setup.iosicon
  }, null, 8, _hoisted_3), _hoisted_4, _hoisted_5, _createElementVNode("div", {
    class: "down-btn",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.downIos && $setup.downIos(...args))
  }, "免费下载")]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _hoisted_8, _createElementVNode("img", {
    src: $setup.step1,
    class: "step-img"
  }, null, 8, _hoisted_9), _hoisted_10, _createElementVNode("img", {
    src: $setup.step3,
    class: "step-img"
  }, null, 8, _hoisted_11), _hoisted_12, _createElementVNode("img", {
    src: $setup.step4,
    class: "step-img"
  }, null, 8, _hoisted_13), _hoisted_14, _createElementVNode("img", {
    src: $setup.step6,
    class: "step-img"
  }, null, 8, _hoisted_15), _createElementVNode("img", {
    src: $setup.step7,
    class: "step-img"
  }, null, 8, _hoisted_16), _hoisted_17]), $setup.isWechat && $setup.show ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "share-back",
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.close && $setup.close(...args))
  }, [_createElementVNode("img", {
    src: $setup.wechatjt,
    class: "wechatjt"
  }, null, 8, _hoisted_18), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", null, [_hoisted_20, _createElementVNode("img", {
    src: $setup.point,
    class: "point-img"
  }, null, 8, _hoisted_21)]), _createElementVNode("div", null, [_hoisted_22, $setup.isIos ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $setup.safari,
    class: "safari"
  }, null, 8, _hoisted_23)) : _createCommentVNode("", true)])])])) : _createCommentVNode("", true), $setup.isWechat && $setup.show ? (_openBlock(), _createElementBlock("div", _hoisted_24)) : _createCommentVNode("", true)]);
}